import { useContactManagementTranslation } from '../../../../ui/hooks';
import { isEmailValid } from '@juvare/common-form-ui/WidgetFormEmail/utils';
import React from 'react';
export function useChangeLoginEmailFormConfig() {
    const { t } = useContactManagementTranslation();
    return React.useMemo(() => {
        return {
            type: 'form',
            children: [
                {
                    type: 'form.text',
                    label: t('changeLoginEmailDialog.formLabels.currentLoginEmailAddress'),
                    key: 'currentEmailAddress',
                    disabled: true,
                },
                {
                    type: 'form.panel',
                    children: [
                        {
                            type: 'form.content',
                            key: 'content',
                            html: `<p class="subtitle2">${t('changeLoginEmailDialog.formLabels.newLoginEmailAddress')}</p>`,
                        },
                        {
                            type: 'form.text',
                            label: t('changeLoginEmailDialog.formLabels.addNewEmailAddress'),
                            key: 'newEmailAddress',
                            validate: {
                                required: true,
                                requiredMessage: t('changeLoginEmailDialog.formLabels.validation.emailIsRequired'),
                                custom: (value) => {
                                    if (value && isEmailValid(value)) {
                                        return;
                                    }
                                    return t('changeLoginEmailDialog.formLabels.validation.invalidEmail');
                                },
                            },
                        },
                        {
                            type: 'form.text',
                            label: t('changeLoginEmailDialog.formLabels.confirmNewEmailAddress'),
                            key: 'confirmNewEmailAddress',
                            validate: {
                                required: true,
                                requiredMessage: t('changeLoginEmailDialog.formLabels.validation.emailIsRequired'),
                                custom: (value, handler) => {
                                    var _a;
                                    const newEmail = (_a = handler.up().down('newEmailAddress')) === null || _a === void 0 ? void 0 : _a.getData();
                                    if (value && isEmailValid(value)) {
                                        if (newEmail === value) {
                                            return;
                                        }
                                        return t('changeLoginEmailDialog.formLabels.validation.emailDontMatch');
                                    }
                                    return t('changeLoginEmailDialog.formLabels.validation.invalidEmail');
                                },
                            },
                        },
                    ],
                    style: {
                        horizontalAlign: 'left',
                        surface: 'level1',
                    },
                },
                {
                    type: 'form.content',
                    html: `<p class="subtitle2">${t('changeLoginEmailDialog.changeLoginEmailInfoText')}</p>`,
                    style: {
                        alert: 'info',
                    },
                },
            ],
        };
    }, [t]);
}
